<div class="modal-body content width-500">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header')}}
    </span>

    <div class="content">
      <div style="margin-bottom: 1rem;">
        <h6>{{getRessource('EmailSection')}}</h6>
        <div class="typo-small c-red"
             style="margin-left: 1rem;">
          <i class="fa-regular fa-circle-info"></i>
          {{getRessource('EmailHint')}}
        </div>
        <exg-input [(ngModel)]="dataModelEmailClone.kontVal"
                   [caption]="getRessource('EmailCaption')">
        </exg-input>
        <div *ngIf="dataModelEmailClone.kontVal && !isValidEmail()"
             class="typo-small c-red"
             style="margin-left: 1rem; margin-bottom: 0.75rem;">
          {{getRessource('EmailInvalid')}}
        </div>
        <ng-container *ngIf="data?.emailList?.length">
          <div class="list-metadata">{{getRessource('EmailExisting')}}</div>
          <div class="list-row list-row-1-auto"
               style="padding-top: 0.125rem;padding-bottom: 0.125rem;"
               *ngFor="let email of data.emailList">
            <div class="list-primary-text">
              {{email.kontVal}}
            </div>
            <div>
              <span *ngIf="isEmailMarked(email)"
                    class="typo-small c-green">
                <i class="fa-regular fa-check"></i>
                {{getRessource('EmailRemoveMarked')}}
              </span>
              <i *ngIf="isEmailMarked(email)"
                 class="search-action far fa-undo"
                 [title]="getRessource('EmailRemoveUndo')"
                 (click)="undoRemoveEmail(email)">
              </i>
              <i *ngIf="!isEmailMarked(email)"
                 class="search-action far fa-trash-alt"
                 [title]="getRessource('EmailRemove')"
                 (click)="removeEmail(email)">
              </i>
            </div>
          </div>
        </ng-container>
      </div>

      <div style="margin-bottom: 1rem;">
        <h6>{{enumSvc.getEnumerationText('KontaktTyp', dataModelPhoneClone.kont_enmIdent_KontaktTyp)}}</h6>
        <div class="grid cols-3">
          <app-exg-select-enumeration
            [(value)]="dataModelPhoneClone.kont_enmIdent_KontaktTyp"
            [caption]="getRessource('PhoneTypeCaption')"
            [enumerationList]="phoneTypList"
            name="phoneType">
          </app-exg-select-enumeration>

          <exg-input [(ngModel)]="dataModelPhoneClone.kontVal"
                     [caption]="enumSvc.getEnumerationText('KontaktTyp', dataModelPhoneClone.kont_enmIdent_KontaktTyp)"
                     class="span-2">
          </exg-input>
        </div>
      </div>

      <div style="margin-bottom: 1rem;">
          <h6>{{getRessource('Schadensparameter')}}</h6>
          <div class="grid cols-2">
            <div>
              <div *ngIf="data?.aueReserve !== undefined"
                   class="typo-small" style="margin-left: 1rem;">
                {{getRessource('CurrentReserve')}} {{ data?.aueReserve | number:'1.2-2':'de' }} €
              </div>
              <exg-input [(ngModel)]="reserve"
                         [caption]="'Excon Reserve (€)'">
              </exg-input>
              <div *ngIf="reserve && !isValidCurrency(reserve)"
                   class="typo-small c-red"
                   style="margin-left: 1rem;">
                {{getRessource('ValidCurrencyFormat')}}
              </div>
            </div>
            <div>
              <div *ngIf="data?.aueSelbstbehalt !== undefined"
                   class="typo-small"
                   style="margin-left: 1rem;">
                {{getRessource('CurrentSelbstbehalt')}} {{ data?.aueSelbstbehalt | number:'1.2-2':'de' }} €
              </div>
              <exg-input [(ngModel)]="selbstbeteiligung"
                         [caption]="'Selbstbeteiligung (€)'">
              </exg-input>
              <div *ngIf="selbstbeteiligung && !isValidCurrency(selbstbeteiligung)"
                   class="typo-small c-red"
                   style="margin-left: 0.5rem;">
                {{getRessource('ValidCurrencyFormat')}}
              </div>
            </div>
          </div>
      </div>
      <div style="margin-bottom: 1rem;">
        <exg-textarea
          [(ngModel)]="comment"
          [caption]="'Hinweise für den Innendienst (z.B. falsche VN Daten XY bitte löschen)'"
          type="text"
          [maxlength]="4000">
        </exg-textarea>
      </div>
    </div>

    <div class="spawn-modal-actions typo-small">
      <button (click)="cancel()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
      <button (click)="save()"
              [class.disabled]="!canSave()"
              [disabled]="!canSave()"
              class="md-btn">
        {{getGlobal('Save')}}
      </button>
    </div>
  </div>
</div>
